/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FinOpsDto } from '../models/fin-ops-dto';
import { MessageBto } from '../models/message-bto';

@Injectable({
  providedIn: 'root',
})
export class AmnicIntegrationControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation removeOidcWhitelistedDomains
   */
  static readonly RemoveOidcWhitelistedDomainsPath = '/api/v1/amnic/whitelist/remove';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeOidcWhitelistedDomains()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeOidcWhitelistedDomains$Response(params: {
    body: {
[key: string]: Array<string>;
}
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AmnicIntegrationControllerService.RemoveOidcWhitelistedDomainsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeOidcWhitelistedDomains$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeOidcWhitelistedDomains(params: {
    body: {
[key: string]: Array<string>;
}
  }): Observable<void> {

    return this.removeOidcWhitelistedDomains$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation addOidcWhitelistedDomains
   */
  static readonly AddOidcWhitelistedDomainsPath = '/api/v1/amnic/whitelist/add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addOidcWhitelistedDomains()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addOidcWhitelistedDomains$Response(params: {
    body: FinOpsDto
  }): Observable<StrictHttpResponse<MessageBto>> {

    const rb = new RequestBuilder(this.rootUrl, AmnicIntegrationControllerService.AddOidcWhitelistedDomainsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MessageBto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addOidcWhitelistedDomains$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addOidcWhitelistedDomains(params: {
    body: FinOpsDto
  }): Observable<MessageBto> {

    return this.addOidcWhitelistedDomains$Response(params).pipe(
      map((r: StrictHttpResponse<MessageBto>) => r.body as MessageBto)
    );
  }

  /**
   * Path part for operation createTeamAndSetupUser1
   */
  static readonly CreateTeamAndSetupUserPath = '/api/v1/amnic/createTeamAndSetupUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTeamAndSetupUser1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTeamAndSetupUser$Response(params: {
    body: {
[key: string]: string;
}
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, AmnicIntegrationControllerService.CreateTeamAndSetupUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTeamAndSetupUser1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTeamAndSetupUser(params: {
    body: {
[key: string]: string;
}
  }): Observable<string> {

    return this.createTeamAndSetupUser$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation getOidcWhitelistedDomains
   */
  static readonly GetOidcWhitelistedDomainsPath = '/api/v1/amnic/whitelist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOidcWhitelistedDomains()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOidcWhitelistedDomains$Response(params?: {
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, AmnicIntegrationControllerService.GetOidcWhitelistedDomainsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOidcWhitelistedDomains$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOidcWhitelistedDomains(params?: {
  }): Observable<Array<string>> {

    return this.getOidcWhitelistedDomains$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

}
